import { useMediaQuery } from "@mui/material";
import { useCaptureEventsV2 } from "@gx1/gx-npm-lib";
import { IconButton, MiniButton, TypographyComponent } from "@gx1/gx-npm-ui";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { ClientEvent } from "../../../app.constants";
import { MainNavAppV2Context } from "../../../app-v2.context";
import { unreadCountToString } from "../notifications.lib";
import ArrowLeftIcon from "./arrow-left.icon";
import BellIcon from "./bell.icon";
import CloseIcon from "./close.icon";
import styles from "./notifications-header.styles.module.scss";

const NotificationsHeaderComponent = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { notificationCount, setIsNotificationsPanelOpen, setNotifications } = useContext(MainNavAppV2Context);
  const isDesktopView = useMediaQuery("(min-width: 768px)");
  const captureEvents = useCaptureEventsV2();

  const handleClose = () => {
    setIsNotificationsPanelOpen(false);
  };

  const handleMarkAllAsRead = async () => {
    setIsLoading(true);
    captureEvents([{ eventType: ClientEvent.NOTIFICATIONS_FEED_MARK_ALL_AS_READ_CLICKED }]);
    try {
      const response = await fetch(`${window.gxApiConnection}/api/v2/user/notifications/read-all`, {
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        method: "POST",
      });
      if (!response.ok) {
        throw new Error();
      }
      setNotifications((prev) => prev.map((notification) => ({ ...notification, isRead: true })));
    } catch {} finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.root}>
      {isDesktopView && (
        <div className={styles.topDesktopSection}>
          <div className={styles.topLeft}>
            <BellIcon className={styles.icon} />
            <TypographyComponent boldness="medium" color="black" element="h1" styling="p4">
              {t("All Notifications")}
            </TypographyComponent>
          </div>
          <IconButton
            ariaLabel={t("close notifications")}
            width={24}
            height={24}
            borderRadius="50%"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </div>
      )}
      {!isDesktopView && (
        <div className={styles.topMobileSection}>
          <IconButton
            ariaLabel={t("close notifications")}
            width={24}
            height={24}
            onClick={handleClose}
          >
            <ArrowLeftIcon />
          </IconButton>
          <div className={styles.headerText}>
            <TypographyComponent boldness="medium" color="black" element="h1" styling="p3">
              {t("Notifications")}
            </TypographyComponent>
          </div>
        </div>
      )}
      <div className={styles.bottomSection}>
        <TypographyComponent boldness="regular" color="coal" styling="p5">
          {`${t("Unread Notifications")} (${unreadCountToString(notificationCount)})`}
        </TypographyComponent>
        <MiniButton disabled={isLoading} onClick={handleMarkAllAsRead}>
          {t("Mark All as Read")}
        </MiniButton>
      </div>
    </div>
  );
};

export default NotificationsHeaderComponent;
